import React, { useEffect, useState } from 'react';
import UtilityBar from './js/components/UtilityBar/UtilityBar';
import Spinner from './js/components/atoms/Spinner/Spinner';

export default function UtilityRoot({ changeLabel }) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false); // Set loading state to false after app mounts.
  }, []);

  return <>{isLoading ? <Spinner theme="white" /> : <UtilityBar changeLabel={changeLabel} />}</>;
}
